import script from "./AssessmentStaffTraining.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentStaffTraining.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentStaffTraining.vue?vue&type=style&index=0&id=c81c3ba6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c81c3ba6"]])

export default __exports__